import {Button} from "./button";
import {ArrowUpDown} from "lucide-react";
import React from "react";
import {Link} from "react-router-dom";

// type SortButtonProps = {
//     column: any,
//     name: string
// }

type SortableColumn<T> = {
    toggleSorting: (desc: boolean) => void;
    getIsSorted: () => 'asc' | 'desc' | false;
};

type SortButtonProps<T> = {
    column: SortableColumn<T>;
    name: string;
};


export function SortableHeader<T>({ column, name }: SortButtonProps<T>) {
    /**
     * Standard sortable header for shadcn table
     * todo - type the column properly so we can get rid of 'any'
     * */
    return (
        <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
            {name}
            <ArrowUpDown className="ml-2 h-4 w-4"/>
        </Button>
    )
}

export function LinkedCell(row: any) {
    /**
     * Standard sortable header for shadcn table
     * todo - type the column properly so we can get rid of 'any'
     * */

    return


}
